<template>

<svg 
	 xmlns="http://www.w3.org/2000/svg"   
	 viewBox="-11.5 780.5 24 24" >
<path d="M0.5,802.5c-5.51,0-10-4.49-10-10s4.49-10,10-10s10,4.49,10,10S6.01,802.5,0.5,802.5z M0.5,800.5c1.85,0,3.55-0.63,4.9-1.68
	L-5.82,787.6c-1.05,1.35-1.68,3.05-1.68,4.91C-7.5,796.93-3.93,800.5,0.5,800.5L0.5,800.5z M6.82,797.41
	c1.05-1.35,1.68-3.05,1.68-4.9c0-4.43-3.57-8-8-8c-1.85,0-3.55,0.63-4.9,1.68L6.82,797.41L6.82,797.41z"/>
<path d="M-3.33,801.74l-5.41-5.41v-7.65l5.41-5.41h7.65l5.41,5.41v7.65l-5.41,5.41H-3.33z M-3.5,796.5h8v-8h-8V796.5z"/>
</svg>

</template>